// extracted by mini-css-extract-plugin
export default {"wrapper":"Notifications_wrapper__RqooD","notifications":"Notifications_notifications__yLbQK","notification":"Notifications_notification__EmC2d"};